import React from "react";
import { Button, Form } from "react-bootstrap";
import { Box, Stack, Typography } from "@mui/material";
import { useCompactLayout } from "../../../components/responsive";
import { TICKET_CATEGORIES } from "./ticketDisplay";

export function TicketListToolbar({
  categoryFilter,
  statusFilter,
  priorityFilter,
  searchKey,
  onFilterChange,
  onSearch,
  onClear,
  onSearchClick,
}: {
  categoryFilter: string;
  statusFilter: string;
  priorityFilter: string;
  searchKey: string;
  onFilterChange: (type: string, value: string) => void;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  onSearchClick: () => void;
}) {
  const { containerRef, isCompact } = useCompactLayout();
  const showClear = Boolean(categoryFilter || statusFilter || priorityFilter);

  return (
    <Box ref={containerRef} sx={{ width: "100%", minWidth: 0 }}>
      <Typography className="card-title" variant="h6" sx={{ mb: 1.5 }}>
        New Tickets
      </Typography>
      <Stack
        direction={isCompact ? "column" : "row"}
        spacing={1}
        alignItems={isCompact ? "stretch" : "center"}
        justifyContent="space-between"
        flexWrap="wrap"
        useFlexGap
        sx={{ width: "100%", minWidth: 0 }}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
          sx={{ width: isCompact ? "100%" : "auto" }}
        >
          <Form.Select
            value={categoryFilter}
            onChange={(e) => onFilterChange("category", e.target.value)}
            size="sm"
            className="rounded-pill"
            style={{ width: isCompact ? "100%" : "auto" }}
          >
            <option value="">Category</option>
            {TICKET_CATEGORIES.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </Form.Select>
          <Form.Select
            value={statusFilter}
            onChange={(e) => onFilterChange("status", e.target.value)}
            size="sm"
            className="rounded-pill"
            style={{ width: isCompact ? "100%" : "auto" }}
          >
            <option value="">Status</option>
            <option value="NEW">New</option>
            <option value="INPROGRESS">In Progress</option>
            <option value="CLOSED">Closed</option>
          </Form.Select>
          <Form.Select
            value={priorityFilter}
            onChange={(e) => onFilterChange("priority", e.target.value)}
            size="sm"
            className="rounded-pill"
            style={{ width: isCompact ? "100%" : "auto" }}
          >
            <option value="">Priority</option>
            <option value="LOW">Low</option>
            <option value="MEDIUM">Medium</option>
            <option value="HIGH">High</option>
          </Form.Select>
          {showClear && (
            <Button
              variant="outline-danger"
              size="sm"
              className="rounded-pill"
              onClick={onClear}
            >
              Clear
            </Button>
          )}
        </Stack>

        <Box
          className="position-relative shadow-sm rounded-pill overflow-hidden"
          sx={{
            flex: isCompact ? "1 1 auto" : "0 1 360px",
            width: isCompact ? "100%" : 360,
            minWidth: 0,
          }}
        >
          <Form.Control
            type="text"
            placeholder="Search tickets..."
            value={searchKey}
            onChange={onSearch}
            className="form-control border-0 py-2 ps-5"
            style={{
              height: "3rem",
              borderRadius: "50px",
              backgroundColor: "#f8f9fa",
            }}
          />
          <span
            className="position-absolute top-50 start-0 translate-middle-y ps-3"
            style={{ color: "#6c757d", fontSize: "1.1rem" }}
          >
            🔍
          </span>
          <Button
            variant="primary"
            onClick={onSearchClick}
            className="position-absolute top-0 end-0 rounded-pill px-4 py-2"
            style={{
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              lineHeight: 2,
            }}
          >
            Search
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
